<!--
 * @Descripttion: 
 * @version: 
 * @Author: 
 * @Date: 2022-06-08 10:04:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-10-22 19:02:29
-->
<template>
  <div class="c-app">
    <TheSidebar />
    <CWrapper>
      <TheHeader @getData="handerData" />
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade" mode="out-in">
              <router-view :key="$route.path"></router-view>
            </transition>
          </CContainer>
        </main>
        <!-- <div class="visi-qrcode-box" v-if="visiQrCode">
          <div class="qrcode">
            <img style="width:100%;height:100%" src="../assets/tgqr.jpg" alt="">
          </div>
        </div> -->
        <el-dialog
          title=""
          :visible.sync="visiQrCode"
          width="30%"
          show-close
          @close="closeQrCode"
          center>
          <div class="qrcode">
            <!-- <img style="width:100%;height:100%" src="../assets/tgqr.jpg" alt=""> -->
            <el-image :src="tgqr3">
              <div slot="placeholder" class="image-slot" lazy>
                Loading<i class="el-icon-loading" style="font-size:20px"></i>
              </div>
            </el-image>
            <div style="background:#fdf6ec;color:#e6a23c;padding:5px 5px;">
              <div>{{$t('navbar.tgqr3Tip1')}}<a style="color:#4DA2FF;text-decoration:underline;" href="https://t.me/FotonCardCS" target="_blank"> {{ $t('navbar.tgqr3Tip2')}}</a> {{ $t('navbar.tgqrTip3')}}<b> {{ $t('navbar.tgqrTip4')}}</b></div>
            </div>
            <!-- <el-image style="width:100%;height:100%" :src="src" lazy>
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image> -->
          </div>
          <!-- <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
          </span> -->
        </el-dialog>
        <el-dialog
          title=""
          :visible.sync="visiChannelQrCode"
          width="30%"
          show-close
          @close="closeChannelQrCode"
          center>
          <div class="qrcode">
            <!-- <img style="width:100%;height:100%" src="../assets/tgchannel.jpg" alt=""> -->
            <el-image :src="tgchannel" lazy>
              <div slot="placeholder" class="image-slot">
                Loading<i class="el-icon-loading" style="font-size:20px"></i>
              </div>
            </el-image>
          </div>
        </el-dialog>
      </div>
      <TheFooter/>
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import request from '../api/request'

export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheHeader,
    TheFooter
  },
  data() {
    return {
      sideData: [],
      // tgqr: require('../assets/tgqr.jpg'),
      tgqr: require('../assets/whatsapp.jpg'),
      tgqr3: require('../assets/new_tg.jpg'),
      tgchannel: require('../assets/new_channel.jpg')
      // src: "../assets/tgqr.jpg"
    }
  },
  computed: {
    visiQrCode() {
      return this.$store.state.visiQrCode
    },
    visiChannelQrCode() {
      return this.$store.state.visiChannelQrCode
    }
  },
  methods: {
    handerData(item) {
      // console.log("Contain===>", item)
      if(item) {
        this.sideData = item
      }
    },
    closeQrCode() {
      this.$store.commit('setVisiQrCode', false)
    },
    closeChannelQrCode() {
      this.$store.commit('setVisiChannelQrCode', false)
    }
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.qrcode{
  width: 100%;
}
</style>
